import { feature as assetFeature } from '@/domain/enums/asset';

const AssetInformation = () => import(/* webpackChunkName: "assetInformation" */ '../AssetInformation');
const AssetInformationIndex = () => import(/* webpackChunkName: "assetInformation" */ '../index');
const BaseGeneralData = () => import(/* webpackChunkName: "baseGeneralData" */ '@/app/installation/assetInformation/common/BaseGeneralData');
const Files = () => import(/* webpackChunkName: "assetInformationFiles" */ '@/app/installation/assetInformation/common/Files');
const RegistrationData = () => import(/* webpackChunkName: "registrationData" */ '@/app/installation/assetInformation/common/registrationData');
const TransformersCoolingStages = () => import(/* webpackChunkName: "coolingStages" */ '@/app/installation/assetInformation/transformers/coolingStages/CoolingStages');
const TransformersLosses = () => import(/* webpackChunkName: "losses" */ '@/app/installation/assetInformation/transformers/losses');

export const assetInformationRouteFeatures = {
  'dados-cadastrais': assetFeature.REGISTRATION_DATA,
  'dados-gerais': assetFeature.GENERAL_DATA,
  perdas: assetFeature.LOSSES,
  'estagios-resfriamento': assetFeature.COOLING_STAGES,
  arquivos: assetFeature.FILES,
};

export default {
  path: 'informacoes-do-ativo',
  name: 'asset-information',
  component: AssetInformationIndex,
  meta: {
    breadcrumb: {
      name: 'page-name.asset-information',
      noTitle: true,
      noNavigation: true,
    },
  },
  redirect: {
    name: 'monitoring',
  },
  children: [
    {
      path: ':assetId',
      name: 'asset-information.asset',
      component: AssetInformation,
      redirect: to => ({
        name: 'monitoring.asset-information.registration-data',
        params: {
          ...to.params,
        },
      }),
      children: [
        {
          path: 'dados-cadastrais',
          name: 'monitoring.asset-information.registration-data',
          component: RegistrationData,
        },
        {
          path: 'dados-gerais',
          name: 'monitoring.asset-information.general-data',
          component: BaseGeneralData,
        },
        {
          path: 'estagios-resfriamento',
          name: 'monitoring.asset-information.cooling-stages',
          component: TransformersCoolingStages,
        },
        {
          path: 'perdas',
          name: 'monitoring.asset-information.losses',
          component: TransformersLosses,
        },
        {
          path: 'arquivos',
          name: 'monitoring.asset-information.files',
          component: Files,
        },
      ],
    },
  ],
};
